module.exports = __webpack_public_path__ + "static/media/Google Adwords@2x.dd4824ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Google Adwords@2x.png
// module id = 90
// module chunks = 0